// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".custom-audio[data-v-5d71a1ae] {\n  display: none;\n}\n", "",{"version":3,"sources":["webpack://./js/app/components/custom/CustomAudio.vue"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf","sourcesContent":[".custom-audio[data-v-5d71a1ae] {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
